var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex title-wrapper align-items-end text-white px-4 pb-4"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"align-items-end"},[_vm._v(" "+_vm._s(_vm.$t(_vm.titleText))+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }